import { url } from "./MongoConstants";

const getTodaysScores = async () => {
    try {
        const server = url;
        const response = await fetch(server + '/api/data/scores/today', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return(data)
        } else {
            console.log('Failed to get scores');
            return('Failed to get scores');
        }
    } catch (error) {
        console.error('An error occurred:', error);
        return('An error occurred:', error);
    }
};

export default getTodaysScores;